import { motion, AnimatePresence } from 'framer-motion'
import './InfoModal.css'

interface InfoModalProps {
    isOpen: boolean
    onClose: () => void
    title: string
    content: React.ReactNode
}

export default function InfoModal({ isOpen, onClose, title, content }: InfoModalProps) {
    if (!isOpen) return null

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="info-modal-overlay" onClick={onClose}>
                    <motion.div
                        className="info-modal glass"
                        initial={{ opacity: 0, scale: 0.95, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.95, y: 20 }}
                        transition={{ type: "spring", duration: 0.5, bounce: 0.3 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="info-modal-header">
                            <h2 className="info-modal-title">{title}</h2>
                            <button className="info-modal-close" onClick={onClose}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M18 6L6 18M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <div className="info-modal-content custom-scrollbar">
                            {content}
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    )
}
